import { ProviderPrivilege } from '~/types';
import { PrivilegesFormValues } from './types';

export const isCustomPrivilegeForm = (
  privilegeForm: Pick<PrivilegesFormValues, 'userAddedFlag'> & {
    privilegeId?: number | null;
  }
): boolean => privilegeForm.userAddedFlag === true || privilegeForm.privilegeId == null;

const parseNumericId = (value: string): number | undefined => {
  const trimmed = value.trim();
  if (!/^\d+$/.test(trimmed)) return undefined;
  const parsed = Number(trimmed);
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : undefined;
};

export const providerPrivilegeFormToApi = (privilegeForm: PrivilegesFormValues): string => {
  const transformedPrivilege = {
    ...privilegeForm,
    privilegeCategory: privilegeForm.category,
    privilegeNotes: privilegeForm.privilegeNotes || '',
    specialtyName: privilegeForm.specialtyName.label,
    specialtyId: Number(privilegeForm.specialtyName.value),
    userAddedFlag: privilegeForm.id ? false : true,
    assignmentDate: privilegeForm.assignmentDate,
  };
  return JSON.stringify(transformedPrivilege);
};

export const providerPrivilegesFormToApi = (privilegesForm: PrivilegesFormValues[]): string => {
  const transformedPrivileges = privilegesForm.map((privilege) => {
    const isObjectSpecialty =
      typeof privilege.specialtyName === 'object' && privilege.specialtyName !== null;
    return {
      ...privilege,
      privilegeCategory: privilege.category,
      privilegeNotes: privilege.privilegeNotes || '',
      specialtyName: isObjectSpecialty ? privilege.specialtyName.label : privilege.specialtyName,
      specialtyId: isObjectSpecialty
        ? Number(privilege.specialtyName.value)
        : privilege.specialtyId,
    };
  });
  return JSON.stringify({ privileges: transformedPrivileges });
};

export const privilegePatchFormToApi = (privilegeForm: PrivilegesFormValues): string => {
  const payload: Record<string, unknown> = {
    id: privilegeForm.id,
    privilegeNotes: privilegeForm.privilegeNotes,
  };
  if (privilegeForm.assignmentDate) {
    payload.assignmentDate = privilegeForm.assignmentDate;
  }
  if (isCustomPrivilegeForm(privilegeForm)) {
    const specialtyId = parseNumericId(privilegeForm.specialtyName.value);
    payload.privilegeName = privilegeForm.privilegeName;
    payload.privilegeType = privilegeForm.privilegeType;
    payload.privilegeCategory = privilegeForm.category;
    payload.specialtyName = privilegeForm.specialtyName.label;
    if (specialtyId !== undefined) {
      payload.specialtyId = specialtyId;
    }
    payload.userAddedFlag = true;
  }
  return JSON.stringify(payload);
};

export const providerPrivilegeApiToForm = (providerPrivilege: string): PrivilegesFormValues => {
  const parsed: ProviderPrivilege = JSON.parse(providerPrivilege);
  return {
    ...parsed,
    specialtyName: {
      label: parsed.specialtyName,
      value: parsed.specialtyId?.toString() || parsed.specialtyName || '',
    },
    category: parsed.privilegeCategory,
    assignmentDate: parsed.assignmentDate
      ? new Date(parsed.assignmentDate).toISOString().split('T')[0]
      : '',
  };
};

export const providerPrivilegesApiToForm = (privilegesStr: string): PrivilegesFormValues[] => {
  const parsed = JSON.parse(privilegesStr);
  return parsed.map((privilege: ProviderPrivilege) =>
    providerPrivilegeApiToForm(JSON.stringify(privilege))
  );
};

export const providerPrivilegesBulkApiToForm = (privilegesStr: string): PrivilegesFormValues[] => {
  const parsed = JSON.parse(privilegesStr).data;
  return parsed.map((privilege: ProviderPrivilege) =>
    providerPrivilegeApiToForm(JSON.stringify(privilege))
  );
};

export const errorHandler = (message: string, err: unknown) => {
  // TODO: MCV-140 - We need a design on how we want to handle errors and how the user is notified.
  console.error(message, err);
};
